export enum CbDataTableColumnType {
  TEXT,
  TRANSLATION,
  STATUS,
  TAG,
  CURRENCY,
  CHECKBOX,
  DATE,
  IMAGE,
  IMAGE_CIRCLE
}

export interface CbDataTableColumn<T> {
  type: CbDataTableColumnType;
  label: string;
  sortKey?: string;
  value?(o: T): any;
  color?(o: T): any;
  bgColor?(o: T): any;
  fontColor?(o: T): any;
}

export interface CbPagination {
  pageSize: number;
  page: number;
  collectionSize: number;
}

export interface CbSort {
  sortKey: string;
  ascending: boolean;
}

export interface CbDataTableOptions<T> {
  sort?: CbSort;
  pagination?: CbPagination;
  noResult?: string;
  header?: boolean;
  columns: CbDataTableColumn<T>[];
  editable?(o: T): boolean;
  deletable?(o: T): boolean;
  progress?(o: T): number;
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/+admin/modules/cb-data-table/cb-data-table-options.ts